import type { AnalyticsConsent } from "@/lib/analyticsConsent";

const rewardfulId = import.meta.env.VITE_REWARDFUL_CAMPAIGN_ID || "293419";
const gateByConsent = import.meta.env.VITE_REWARDFUL_CONSENT_GATE === "true";
let rewardfulInitialized = false;

const ensureRewardfulQueue = () => {
  const w = window as typeof window & {
    rewardful?: ((...args: unknown[]) => void) & { q?: unknown[] };
    _rwq?: string;
  };

  if (!w.rewardful) {
    w._rwq = "rewardful";
    w.rewardful = (...args: unknown[]) => {
      const queue = w.rewardful?.q || [];
      w.rewardful.q = queue;
      queue.push(args);
    };
  }
};

export const maybeInitRewardful = (consent: AnalyticsConsent) => {
  if (rewardfulInitialized) return;
  if (gateByConsent && consent !== "accepted") return;
  if (!rewardfulId) return;
  if (typeof document === "undefined") return;

  ensureRewardfulQueue();

  if (document.getElementById("rewardful-script")) {
    rewardfulInitialized = true;
    return;
  }

  const script = document.createElement("script");
  script.async = true;
  script.src = "https://r.wdfl.co/rw.js";
  script.id = "rewardful-script";
  script.dataset.rewardful = rewardfulId;
  document.head.appendChild(script);
  rewardfulInitialized = true;
};

export const getClientReferenceId = (): string | null => {
  if (typeof window === "undefined") return null;
  const ref = window.Rewardful?.referral;
  if (typeof ref !== "string") return null;
  const trimmed = ref.trim();
  return trimmed.length > 0 ? trimmed : null;
};
